module.exports = __webpack_public_path__ + "img/1.ff19b028.jpg";